import React, { useState } from 'react';
import ConfirmationModal from '@grnhse/seedling/lib/birch/components/modals/confirmation_modal';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import { SelectionsHelper } from 'talent_matching/hooks/use_selections_helper';
import { standardRequestWithErrorFlash } from 'shared/utils/request';
import useQueryHelper from 'talent_matching/hooks/use_query_helper';
import { useUserContext } from 'talent_matching/contexts/user_context';
import { useAdvancedCandidateCount } from 'talent_matching/contexts/advanced_candidate_count_context';

const t = withLocalePrefix('talent_matching.bulk_actions.advance');

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  selectionsHelper: SelectionsHelper;
  advanceStagePath: string;
};

const AdvanceModal = ({
  isOpen,
  closeModal,
  selectionsHelper,
  advanceStagePath,
}: Props) => {
  const [submitting, setSubmitting] = useState(false);
  const { excludePeople } = useQueryHelper();
  const { appReviewSessionId } = useUserContext();
  const { onBulkAdvanceSuccess } = useAdvancedCandidateCount();

  const onSubmit = async () => {
    const payload = {
      hiring_plan_interview_stage_id: selectionsHelper.toStageId,
      application_ids: selectionsHelper.applicationIds,
      app_review_session_id: appReviewSessionId,
      source: 'talent_matching',
    };

    setSubmitting(true);

    try {
      await standardRequestWithErrorFlash.post(advanceStagePath, payload, {
        successMessage: t('success'),
      });
      onBulkAdvanceSuccess(selectionsHelper.selectedPeople);
      excludePeople(selectionsHelper.applicationIds);
      closeModal();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onDismiss={closeModal}
      ariaLabel={t('title')}
    >
      <ConfirmationModal.Header>
        {t('title', { count: selectionsHelper.totalSelected })}
      </ConfirmationModal.Header>
      <ConfirmationModal.Body>
        <Body className="pii-blur">
          {t('body', {
            from: selectionsHelper.fromStageName,
            to: selectionsHelper.toStageName,
          })}
        </Body>
      </ConfirmationModal.Body>
      <ConfirmationModal.Footer>
        <SecondaryButton onClick={closeModal} disabled={submitting}>
          {t('cancel')}
        </SecondaryButton>
        <PrimaryButton onClick={onSubmit} disabled={submitting}>
          {t('confirm')}
        </PrimaryButton>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};

export default AdvanceModal;
